/*
 * TunePad
 *
 * Michael S. Horn
 * Northwestern University
 * michael-horn@northwestern.edu
 *
 * This project was funded by the National Science Foundation (grant DRL-1612619).
 * Any opinions, findings and conclusions or recommendations expressed in this
 * material are those of the author(s) and do not necessarily reflect the views
 * of the National Science Foundation (NSF).
 */
import html from './key-dialog.module.html';

/**
 * Key Dialog
 */

export function showKeyDialog(key : string, update : (key : string) => void) {

    const dialog = document.createElement('dialog');
    dialog.innerHTML = html;
    dialog.classList.add('key-dialog');
    dialog.setAttribute('key', key);
    document.body.append(dialog);
    dialog.showModal();
    dialog.addEventListener('click', (event) => {
        const r = dialog.getBoundingClientRect();
        const cx = event.clientX;
        const cy = event.clientY;
        if (cy < r.top || cy > r.bottom || cx < r.left || cx > r.right) {
            dialog.close();
            dialog.remove();
        }
    });

    dialog.querySelector('circle-of-fifths')?.addEventListener('selected', e => {
        update((e as CustomEvent).detail.value);
        dialog.close();
        dialog.remove();
    });
}

